"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = exports.playerColorClass = void 0;
exports.intersection = intersection;
exports.hasIntersection = hasIntersection;
exports.oneWayDifference = oneWayDifference;
exports.twoWayDifference = twoWayDifference;
exports.inplaceRemove = inplaceRemove;
exports.inplaceRemoveIf = inplaceRemoveIf;
exports.sum = sum;
exports.partition = partition;
exports.zip = zip;
exports.asArray = asArray;
exports.definedOrThrow = definedOrThrow;
exports.deNull = deNull;
exports.partialize = partialize;
exports.copyAndClear = copyAndClear;
exports.toName = toName;
exports.toID = toID;
exports.getEnumKeys = getEnumKeys;
exports.getEnumStringValues = getEnumStringValues;
exports.getEnumStringEntries = getEnumStringEntries;
exports.cast = cast;
const playerColorClass = (color, type) => {
    const prefix = {
        shadow: 'player_shadow_color_',
        bg_transparent: 'player_translucent_bg_color_',
        bg: 'player_bg_color_',
    }[type];
    return `${prefix}${color}`;
};
exports.playerColorClass = playerColorClass;
const range = (n) => Array.from(Array(n).keys());
exports.range = range;
function intersection(a, b) {
    return a.filter((e) => b.includes(e));
}
function hasIntersection(a, b) {
    return a.some((e) => b.includes(e));
}
function oneWayDifference(a, b) {
    const remainder = [...a];
    for (const elem of b) {
        inplaceRemove(remainder, elem);
    }
    return remainder;
}
function twoWayDifference(a, b) {
    return a
        .filter((x) => !b.includes(x))
        .concat(b.filter((x) => !a.includes(x)));
}
function inplaceRemove(array, element) {
    return inplaceRemoveIf(array, (e) => e === element) !== undefined;
}
function inplaceRemoveIf(array, predicate) {
    const idx = array.findIndex(predicate);
    if (idx === -1) {
        return undefined;
    }
    const element = array[idx];
    array.splice(idx, 1);
    return element;
}
function sum(array) {
    return array.reduce((a, b) => a + b, 0);
}
function partition(source, predicate) {
    return source.reduce((result, element) => {
        result[predicate(element) ? 0 : 1].push(element);
        return result;
    }, [[], []]);
}
function zip(first, second) {
    return first.map((e, i) => [e, second[i]]);
}
function asArray(elem) {
    return Array.isArray(elem) ? elem : [elem];
}
function definedOrThrow(obj) {
    if (obj === undefined) {
        throw new Error('object is undefined');
    }
    return obj;
}
function deNull(array) {
    const output = [];
    for (const elem of array) {
        if (elem !== undefined) {
            output.push(elem);
        }
    }
    return output;
}
function partialize(record) {
    const partial = {};
    for (const e in record) {
        if (record[e] !== 0) {
            partial[e] = record[e];
        }
    }
    return partial;
}
function copyAndClear(array) {
    const copy = [...array];
    array.length = 0;
    return copy;
}
function toName(item) {
    return item.name;
}
function toID(item) {
    return item.id;
}
function getEnumKeys(enumObject) {
    return Object.keys(enumObject);
}
function getEnumStringValues(enumObject) {
    return Object.values(enumObject);
}
function getEnumStringEntries(enumObject) {
    return Object.entries(enumObject);
}
function cast(obj, klass) {
    if (klass === undefined) {
        if (obj !== undefined) {
            throw new Error(`Expected undefined, got type ${obj.constructor.name}`);
        }
        return undefined;
    }
    if (!(obj instanceof klass)) {
        throw new Error(`Not an instance of ${klass.name}: ${obj?.constructor?.name}`);
    }
    return obj;
}
